import React from 'react';
import { useParams } from 'react-router-dom';

import InitPassword from 'components/authentication/InitPassword';

const InitPasswordBlankPage = () => {
    let { tokenInitMdp } = useParams();

    return (
        <InitPassword
            tokenInitMdp={tokenInitMdp}
        />
    );
};

export default InitPasswordBlankPage;
